import { useState, useEffect, useCallback, useRef } from 'react';

export default function usePolling(fetchFn, intervalMs = 10000) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const intervalRef = useRef(null);

  const load = useCallback(async () => {
    try {
      const result = await fetchFn();
      setData(result);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [fetchFn]);

  useEffect(() => {
    load();
    intervalRef.current = setInterval(load, intervalMs);
    return () => clearInterval(intervalRef.current);
  }, [load, intervalMs]);

  const refresh = useCallback(() => {
    setLoading(true);
    load();
  }, [load]);

  return { data, loading, error, refresh };
}
